import React from 'react';
import { Platform } from 'react-native';
import * as Screens from 'react-native-screens';

/**
 * Wrap children in TWO screens otherwise some elements can't be interacted with
 * (i.e. dialogs with buttons, sync summary, sync indicator)
 */

export const ScreenOverlay: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) =>
  Platform.OS === 'ios' ? (
    <Screens.FullWindowOverlay>
      {/* <Screens.FullWindowOverlay style={StyleSheet.absoluteFill}> */}
      {children}
      {/* </Screens.FullWindowOverlay> */}
    </Screens.FullWindowOverlay>
  ) : (
    <>{children}</>
  );
